import React, { useState } from "react";
import styles from "./PreviewSignature.module.scss";
import Modal from "react-modal";
import SignatureCanvas from "react-signature-canvas";
import { ReactComponent as SignIcon } from "assets/svg/user-pen-com.svg";
import sign from "../../../../../assets/svg/sign.svg"
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
const PreviewSignature = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [signature, setSignature] = useState(null);
  const sigCanvas = React.useRef({});
  const [showIcon, setShowIcon] = useState(
    props?.data?.showInstructions || false
  );
  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const clearSignature = () => {
    sigCanvas.current.clear();
  };

  const saveSignature = () => {
    setSignature(sigCanvas.current.getTrimmedCanvas().toDataURL("image/png"));
    closeModal();
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContent}>
        <div className={styles.heading}>
          {props?.data?.required && <span style={{ color: "red" }}>*</span>}
          <span>{props?.data?.value || props?.name || props?.label}</span>
          {props?.instructions || props?.data?.media?.length ? (
            <div>
              {showIcon ? (
                <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
              ) : (
                <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
              )}
            </div>
          ) : null}
        </div>
        {signature && <img src={signature} className={styles.sign} />}
        <div
          className={styles.rightDiv}
          onClick={() => setModalIsOpen((prev) => !prev)}
        >
          {/* <SignIcon className={styles.signIcon} /> */}
          <p className={styles.textField}>
            {signature ? "Change" : "Add a"} Signature
          </p>
          <img src={sign} alt="sign" className={styles.signIcon} />

        </div>
        {showIcon && (
          <div className={styles.subContent}>
            {props?.instructions && (
              <div className={styles.instructionText}>
                {props?.instructions}
              </div>
            )}
            {props?.data?.media?.length ? (
              <>
                {props?.data?.media.map((image) => (
                  <img
                    className={styles.imageStyle}
                    src={image.path}
                    style={{ width: "100px", height: "100px" }}
                    alt="Preview"
                  />
                ))}
              </>
            ) : null}
          </div>
        )}
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Signature Modal"
        className={styles.modal}
        overlayClassName={styles.overlay}
      >
        <div className={styles.headingDiv}>
          <h3 className={styles.heading}>Form Preview</h3>
          <p className={styles.cross} onClick={closeModal}>
            X
          </p>
        </div>
        <div className={styles.sigCanvas}>
          <SignatureCanvas
            ref={sigCanvas}
            penColor="black"
            canvasProps={{ width: 500, height: 200, border: "1px solid #000" }}
          />
        </div>
        <p className={styles.text}>Sign Here</p>
        <div className={styles.modalfooter}>
          <button onClick={clearSignature}>Clear</button>
          <button onClick={saveSignature}>Done</button>
        </div>
      </Modal>

    </div>
  );
};

export default PreviewSignature;
